import Pagination from '@mui/material/Pagination'

export default Pagination
